import { connect } from 'react-redux'

import {
  getPauseRecoveryContent,
  modalVisibilityChange,
  trackViewDiscountReminder,
  keepSubscription,
  pauseSubscription
} from 'actions/onScreenRecovery'
import { actionTypes } from 'actions/actionTypes'
import { SubPauseOSRView } from './SubPauseOSRView'

const mapStateToProps = (state) => ({
  triggered: state.onScreenRecovery.getIn(['subscriptionPause', 'triggered']),
  title: state.onScreenRecovery.getIn(['subscriptionPause', 'title']),
  offers: state.onScreenRecovery.getIn(['subscriptionPause', 'offers']) && state.onScreenRecovery.getIn(['subscriptionPause', 'offers']).toJS(),
  promoCode: state.onScreenRecovery.getIn(['subscriptionPause', 'promoCode']),
  modalType: state.onScreenRecovery.getIn(['subscriptionPause', 'modalType']),
  isFetching: state.pending.get(actionTypes.SUB_PAUSE_RECOVERY_TRIGGERED),
  pauseReason: state.onScreenRecovery.getIn(['subscriptionPause','pauseReason']),
})

const mapDispatchToProps = {
  onKeep: keepSubscription,
  onConfirm: pauseSubscription,
  modalVisibilityChange,
  getPauseRecoveryContent,
  trackViewDiscountReminder
}

export const SubPauseOSRViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubPauseOSRView)
